import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let StockChartRowsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-stockchart-rows';
        }
    }
});
export const StockChartRowsPlugin = {
    name: 'e-stockchart-rows',
    install(Vue) {
        Vue.component(StockChartRowsPlugin.name, StockChartRowsDirective);
    }
};
export let StockChartRowDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-stockchart-row';
        }
    }
});
export const StockChartRowPlugin = {
    name: 'e-stockchart-row',
    install(Vue) {
        Vue.component(StockChartRowPlugin.name, StockChartRowDirective);
    }
};
